import React, {Fragment} from "react"

import CommonSkill from "./CommonSkill"

const skillContent = [
    {
        number: "80",
        title: "Seguridad Web",
    },
    {
        number: "85",
        title: "Diseño UI/UX",
    },
    {
        number: "88",
        title: "Desarrollo",
    },
    {
        number: "92",
        title: "Diseño",
    },
    {
        number: "90",
        title: "Comunicación",
    },
    {
        number: "92",
        title: "Fotografía",
    },
]

const SkillTwo = () => {
    return (
        <Fragment>
            <div className="row gx-4 gx-xxl-5 progressbar-wrapper mt-30 mb-15">
                {skillContent.map((val, i)=>(
                    <div key={i} className="col-lg-2 col-md-4 col-sm-6">
                        <div className="progressbar-content text-center mb-45">
                            <CommonSkill number={val.number} />
                            <h4 className="semi-title">{val.title}</h4>
                        </div>
                    </div>
                ))}
            </div>
        </Fragment>
    )
}

export default SkillTwo